import "./SiteConfigurationGroupScheduleExceptionInfo.html";
import "./SiteConfigurationGroupScheduleExceptionInfo.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

// tslint:disable-next-line:max-line-length
import SiteConfigurationGroupScheduleExceptionInfoComponentController from "./SiteConfigurationGroupScheduleExceptionInfoComponentController";

export class SiteConfigurationGroupScheduleExceptionInfoComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            exceptions: "<",
            site: "<",
        };
        this.controller = SiteConfigurationGroupScheduleExceptionInfoComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/" +
            "Info/ScheduleException/SiteConfigurationGroupScheduleExceptionInfo.html";
    }
}

module("mmManagePortal").component(
    "irSiteConfigurationGroupScheduleExceptionInfo",
    new SiteConfigurationGroupScheduleExceptionInfoComponent(),
);
